export type TokenProvider = {
    getAccessToken(): Promise<string | null>;
    updateAccessToken(accessToken: string | null): Promise<void>;
    onUnauthorized?(): void;
};

let tokenProvider: TokenProvider | null = null;

export const setTokenProvider = (provider: TokenProvider): void => {
    tokenProvider = provider;
};

export const getTokenProvider = (): TokenProvider | null => {
    return tokenProvider;
};
